// extracted by mini-css-extract-plugin
export default {"ChooseCountCardContainer":"ChooseCountCardContainer_ChooseCountCardContainer__pWsF2","nextButton":"ChooseCountCardContainer_nextButton__5iNU7"};